import styles from './AddRedFlagModal.module.scss';
import { FC } from 'react';
import { BsShieldExclamation } from "react-icons/bs";
import { MdAudiotrack } from "react-icons/md";
import { IChain, ITrack } from '../../../types/types';
import { Button } from 'antd';
import { useAppDispatch, useAppSelector } from '../../../hooks/hooks';
import { postRedFlag } from '../../../redux/slices/chains';


interface AddRedFlagModal {
    onClose: () => void,
    chain: IChain;
}


export const AddRedFlagModal: FC<AddRedFlagModal> = ({ onClose, chain }) => {

    const {track} = chain;
    const {isPostRedFlag} = useAppSelector((state) => state.chains);
    const dispatch = useAppDispatch();

    return <>
        <div className={styles.container} onClick={onClose}>
            <div className={styles.modal_container} onClick={(e) => e.stopPropagation()}>
                {/* <p>Добавить "красную метку"</p> */}
                <BsShieldExclamation className={styles.icon} />

                <div className={styles.desc_container}>
                    <p>Перед тем как отправить заявление о нерабатаспособности трека, вам нужно предварительно проверить авторские права вашего трека, для этого нужно взять трек целиком и полностью залить на YouTube с любым фоном и в творческой студии проверить прилитают ли авторские права на трек. </p>
                </div>

                <div className={styles.track_info}>
                    <MdAudiotrack size={25}/>

                    <div>
                        <p>{track.originalName}</p>
                        <p>ID: {track.id}</p>
                    </div>
                </div>

                <div className={styles.flex_container}>
                    <p>Я проверил авторское право: </p>
                    <Button loading={isPostRedFlag} onClick={() => dispatch(postRedFlag(chain.id))}>Отправить</Button>
                </div>
            </div>
        </div>
    </>

}